import { useReactNativeProps } from '@/domain/app';

import { isAndroid } from '@utils/platform';

export const useCheckIfGoogleWalletAvailable = () => {
    const { supports } = useReactNativeProps();

    return supports?.googleWallet && isAndroid();
};
